import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import SbEditable from 'storyblok-react';
import { NoSsr } from '@material-ui/core';

const GoogleMyBusiness = ({ blok }) => {
	const data = useStaticQuery(graphql`
		query GoogleMyBusinessSiteMetadata {
			site {
				siteMetadata {
					title
				}
			}
		}
	`);

	return (
		<SbEditable content={blok}>
			<NoSsr>
				{blok.embedUrl ? (
					<iframe
						src={blok.embedUrl}
						width="100%"
						height={`${blok.height}px`}
						style={{ border: 'none', display: 'block' }}
						allowFullScreen
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
						title={`${data.site.siteMetadata.title} location on Google Maps`}
					></iframe>
				) : null}
			</NoSsr>
		</SbEditable>
	);
};

export default GoogleMyBusiness;
